export const BRAND = {
  name: "NOORA JEWELS",
  handle: "@NOORAJewels",
  email: "hello@noorajewels.com",
};

export const HERO_IMAGE =
  "https://images.pexels.com/photos/4550855/pexels-photo-4550855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1000";

export const HERO_IMAGE_ALT =
  "https://images.unsplash.com/photo-1618854782156-814c08e0dbb5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export const LIFESTYLE_BANNER =
  "https://images.pexels.com/photos/33787535/pexels-photo-33787535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000";

export const STORY_IMAGE =
  "https://images.unsplash.com/photo-1656473031949-5541282f05a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export const INSTAGRAM_GRID = [
  "https://images.unsplash.com/photo-1708390072830-aa1b5630979f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1618854782156-814c08e0dbb5?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.pexels.com/photos/9247338/pexels-photo-9247338.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
  "https://images.unsplash.com/photo-1633810543462-77c4a3b13f07?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1699800769235-20b3c6cfd696?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.pexels.com/photos/8183945/pexels-photo-8183945.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
];

export const REVIEWS = [
  {
    name: "Aisha",
    rating: 5,
    text: "Absolutely love my necklace! It looks so elegant and I've been wearing it almost every day.",
    location: "Verified Buyer",
  },
  {
    name: "Priya",
    rating: 5,
    text: "Beautiful quality, gorgeous packaging, and the perfect everyday pieces.",
    location: "Verified Buyer",
  },
  {
    name: "Sofia",
    rating: 5,
    text: "Noora Jewels has quickly become my favorite jewelry brand. I get compliments every time.",
    location: "Verified Buyer",
  },
  {
    name: "Mariam",
    rating: 5,
    text: "No tarnish after months of daily wear. Worth every penny — this is everyday luxury.",
    location: "Verified Buyer",
  },
];

export const WHY = [
  { title: "Anti-Tarnish", text: "Designed for long-lasting everyday shine." },
  { title: "Everyday Luxury", text: "Elevated pieces made for every occasion." },
  { title: "Skin-Friendly", text: "Comfortable jewelry designed with everyday wear in mind." },
  { title: "Timeless Design", text: "Classic styles that never go out of fashion." },
];
